import React from "react";
import ProductItem from "./Common/ProductItem";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

function Category() {
    const { categoryName } = useParams();
    const decodedCategory = categoryName ? decodeURIComponent(categoryName) : null;

    const { data } = useSelector((store) => store.products);

    const filtered = decodedCategory
        ? data.filter((p) => p.category?.toLowerCase() === decodedCategory.toLowerCase())
        : data;

    return (
        <main>
            <section className="pt-5 pt-md-7">
                <div className="container">
                    <div className="row justify-content-between">
                        <div className="col-12 mb-4">
                            <h4 className="mb-0">
                                {decodedCategory ? decodedCategory : 'All Medicines'}
                            </h4>
                            <small className="text-muted">
                                {filtered.length} product{filtered.length !== 1 ? 's' : ''} found
                            </small>
                        </div>
                        <div className="col-12">
                            <div className="row">
                                {filtered.length > 0 ? (
                                    filtered.map((product) => (
                                        <div key={product.id} className="col-md-3 col-sm-6 col-12 mb-4">
                                            <ProductItem product={product} />
                                        </div>
                                    ))
                                ) : (
                                    <div className="col-12 text-center py-5">
                                        <p className="text-muted">No products found in this category.</p>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    );
}

export default Category;
